import { msg } from '@lingui/core/macro';
import { Trans, useLingui } from '@lingui/react/macro';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { AppDispatch } from 'store/store';
import UDButton from 'ud-ui/components/button';
import { saveGameDetails } from 'modules/games/store/actions';
import { gameEventsChangedSelector } from 'modules/games/store/selectors';
import { useGameDetails } from 'modules/games/ui/hooks/use-game-details';
import { useGameDetailsFetch } from 'modules/games/ui/hooks/use-game-details-fetch';
import { GameResultHeader } from '../game-result-header';
import MainStreamURL from '../game-result/components/MainStreamURL';
import TimestampUrls from '../game-result/components/timestampUrls';
import EventsList from './components/events-list';
import { useToastApiError } from 'shared/hooks/use-toast-api-error';

interface IProps {
  gameId: number;
  championshipId: number;
}

function MomentsPage(props: IProps) {
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useLingui();
  const toastApiError = useToastApiError();

  const { gameId, championshipId } = props;
  useGameDetailsFetch(gameId, championshipId);

  const { isLoading, data } = useGameDetails();

  const eventsChanged = useSelector(gameEventsChangedSelector);

  const isSaveButtonDisabled = !eventsChanged;

  const handleSaveMomentsUrls = useCallback(() => {
    if (!data) return;
    if (!eventsChanged) return;

    // Без `unwrap` отклонённый thunk резолвился действием — «Сохранено» показывалось и на провале.
    // Промис — кнопке «Сохранить и опубликовать»: она заперта со спиннером до ответа.
    return dispatch(saveGameDetails(data))
      .unwrap()
      .then(({ participantsError }) => {
        toast.success(t`Сохранено`);
        if (participantsError) {
          toastApiError(participantsError, msg`Результат сохранён, но не всех игроков удалось отметить участниками матча`);
        }
      })
      .catch((error) => toastApiError(error, msg`Не удалось сохранить игру`));
  }, [data, dispatch, eventsChanged, t, toastApiError]);

  return (
    <div className={'mb-4'}>
      <GameResultHeader isLoading={isLoading} game={data} />
      <MainStreamURL isLoading={isLoading} game={data} />
      <TimestampUrls isLoading={isLoading} game={data} />
      <div className="mt-9">
        <EventsList game={data} isLoading={isLoading} />
      </div>

      <div className="mt-4 flex justify-start">
        <UDButton variant={'primary'} disabled={isSaveButtonDisabled} onClick={handleSaveMomentsUrls}>
          <Trans>Сохранить и опубликовать</Trans>
        </UDButton>
      </div>
    </div>
  );
}

export default MomentsPage;
